import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const ClockIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon width="20" height="21" viewBox="0 0 20 21" {...props}>
            <path
                d="M10 18.8333C14.6024 18.8333 18.3334 15.1023 18.3334 10.5C18.3334 5.89759 14.6024 2.16663 10 2.16663C5.39765 2.16663 1.66669 5.89759 1.66669 10.5C1.66669 15.1023 5.39765 18.8333 10 18.8333Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <path
                d="M10 5.5V10.5L13.3333 12.1667"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </SvgIcon>
    );
};
